/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsFxNativeStyleOptions } from './FxIdDomainSettingsFxNativeStyleOptions';
import {
    instanceOfFxIdDomainSettingsFxNativeStyleOptions,
    FxIdDomainSettingsFxNativeStyleOptionsFromJSON,
    FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped,
    FxIdDomainSettingsFxNativeStyleOptionsToJSON,
} from './FxIdDomainSettingsFxNativeStyleOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle
 * Настройки визуала для нативных форм FxId (оплата, сбор PI и т.д.)
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle = FxIdDomainSettingsFxNativeStyleOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsFxNativeStyleOptions(json)) {
        return FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsFxNativeStyleOptions(value)) {
        return FxIdDomainSettingsFxNativeStyleOptionsToJSON(value as FxIdDomainSettingsFxNativeStyleOptions);
    }

    return {};
}

